<!-- 欠费设置 -->
<template>
    <div class="container containerBox">
        <cmp-arrearage :form="schemeInfo"
                    @onSave="onSaveArrearage"></cmp-arrearage>
    </div>
</template>

<script>
import Service from '@/api/Service'
import CmpArrearage from '@/components/CmpChargeScheme/CmpArrearage'
export default {
    data () {
        return {
            schemeId: '',
            schemeInfo: {},
        };
    },

    components: {
        CmpArrearage
    },
    created() {
        this.schemeId = this.$route.params.schemeId;
        this.getData(this.schemeId);
    },
    methods: {
        // 获取计费方案明细
        async getData(oid) {
            // let data = await Service.getChargeSchemeInfo({OID : oid});
			let data = await Service.getChargeSchemeList();
            if(data) {
                this.schemeInfo = data;
            }
        },
        // 保存欠费设置
        async onSaveArrearage(params) {
            let data = await Service.editarrearage(params);
            if(data) {
                this.$message({
                    message: '操作成功',
                    type: 'success',
                    duration: 1500,
                });
                this.$router.push('/setchargescheme')
            }
        }
    }
}

</script>
<style lang='css' scoped>
</style>